import { render, staticRenderFns } from "./activeTakeawayWebDialog.vue?vue&type=template&id=0a4790d7&scoped=true"
import script from "./activeTakeawayWebDialog.vue?vue&type=script&lang=js"
export * from "./activeTakeawayWebDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4790d7",
  null
  
)

export default component.exports